import { FC } from "react"
import { IOrder } from "../../../app/reducers/ordersReducer"
import { DataTable, type DataTableColumn } from "../../DataTable/DataTable"
import { TextField } from "@radix-ui/themes"

type CreateNewSuppliesProps = {
  orders: IOrder[]
  newSupplyName: string
}
export const CreateNewSupplies: FC<CreateNewSuppliesProps> = ({
  orders,
  newSupplyName,
}) => {
  const columns: DataTableColumn<IOrder>[] = [
    { key: "id", header: "№ задания" },
    {
      key: "createdAt",
      header: "Создано",
      cell: (el) => new Date(el.createdAt).toLocaleString(),
    },
    { key: "warehouseId", header: "Склад" },
    { key: "article", header: "Артикул продавца" },
    { key: "nmId", header: "Артикул WB" },
    {
      key: "convertedPrice",
      header: "Цена",
      cell: (el) => +el.convertedPrice / 100,
    },
  ]

  return (
    <div>
      <h5>Выбранные позиции</h5>
      <div>
        <label htmlFor="newSupplyName"></label>
        <TextField.Root
          size="3"
          type="text"
          id="newSupplyName"
          value={newSupplyName}
          disabled
        />
        <DataTable
          columns={columns}
          data={orders}
          rowKey={(el, i) => el.article + "-createNewSupp-" + i}
        />
      </div>
    </div>
  )
}
